// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "arrows-sAz3K";
var _4 = "row-2oANU";
var _5 = "headerTitle-3rfXA";
var _6 = "slider_fullConditions-3-t_e";
var _7 = "slider_withoutImages-3sfPf";
export { _1 as "__esModule", _2 as "tablet", _3 as "arrows", _4 as "row", _5 as "headerTitle", _6 as "slider_fullConditions", _7 as "slider_withoutImages" }
export default { "__esModule": _1, "tablet": _2, "arrows": _3, "row": _4, "headerTitle": _5, "slider_fullConditions": _6, "slider_withoutImages": _7 }
